import { collection, getDocs } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Product } from "../types";

export const getProductsByStudioId = async (
  studioId: string,
): Promise<Product[]> => {
  const productsRef = collection(db, `studios/${studioId}/products`);

  const productsSnapshot = await getDocs(productsRef);

  return productsSnapshot.docs.map((product) => product.data() as Product);
};
